// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__p27Jo","row":"Footer_row__1rUav","footerLogo":"Footer_footerLogo__2Uhce","socialIcons":"Footer_socialIcons__2qy8E"};